import { from, Observable, of } from 'rxjs';
import { TranslateLoader } from '@ngx-translate/core';

export function translateLoaderStatic(): TranslateLoader {
    return {
        getTranslation: (lang: string): Observable<Record<string, string>> => {
            switch (lang) {
                case 'pl-PL':
                    return from(import('../../../translations/pl-PL.json').then((json) => json.default));
                default:
                    return of({});
            }
        },
    };
}
